import request from '../../axios';

const getCultivations = async () => {
  const {data}: {data: ICultivations[]} = await request.get(
    `api/v2/farm/monitoring-cultis-list`,
  );

  return data;
};

export default getCultivations;
